
import Slider from "react-slick";
import React, { useEffect } from "react";
import BannerOne from "../../Assetes/Images/banner-offer1.jpg";
import BannerTwo from "../../Assetes/Images/banner-offer2.jpg";
import BannerThree from "../../Assetes/Images/banner-offer3.jpg";
import ReOrder from "../OrderOptions/ReOrder";
import { getLandingBanners } from "../../Redux";
import { connect, useSelector } from "react-redux";
import { IMAGE_URL } from "../../Components/client-config";

function OfferBanner(props: any) {
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
  };
  const landingBanners = useSelector((state: any) => state.menu.landingBanners);
  const storeSelected = useSelector((state: any) => state.store.storeSelected);
  const orderType = useSelector((state: any) => state.payment.orderType);
  useEffect(() => {
    let data: any = {
      banner_type: "landing",
      channel: orderType ? orderType : null,
      store_id: storeSelected ? storeSelected.store_id : null
    }
    props.getLandingBanners(data)
  }, [])
  return (
    <div className="offer-banner">
      <div className="container-fluid p-0">
        <Slider {...settings}>
          {landingBanners && landingBanners.length > 0 ?
            landingBanners.map((item: any, index: any) => {
              return <div key={index} onClick={() => props.selectedItem(item)}>
                <img className='banner-image' src={`${IMAGE_URL}${item.desktop_image}`} alt="" />
              </div>
            })
            : <div />
          }
        </Slider>
        <ReOrder />
      </div>
    </div>
  )
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    getLandingBanners: (data: any) => {
      dispatch(getLandingBanners(data))
    }
  };
};
export default connect(null, mapDispatchToProps)(OfferBanner);